import { AxiosResponse } from 'axios'
import { privateApi } from 'api'
import {
  ILogisticsSettings,
  IUpdateLogisticsSettings
} from 'models/logisticsSettings'

export const logisticsSettingsApi = {
  getSettings: (): Promise<AxiosResponse<ILogisticsSettings>> => {
    return privateApi.get('/logistics-settings')
  },
  updateSettings: (
    data: IUpdateLogisticsSettings
  ): Promise<AxiosResponse<ILogisticsSettings>> => {
    return privateApi.patch('/admin/logistics-settings', data)
  }
}
